<section class="sub-plan-details-container" [class.mobile]="isMobile">

    <div class="details-header">
        <div class="section-title">
            {{ 'text_planDetails' | dbText}}
        </div>
    </div>

    @if (userSubscription?.recharge ||
    ((userSubscription.paymentType === 'paypal') && !paymentMethods?.length && userSubscription.status !== userSubscriptionStatus.canceled)) {
        <div class="db-recharge-wrapper">
            <div class="ds-recharge-banner">
                <div>
                    @if (userSubscription?.recharge) {
                        <div class="db-retry">
                            <i class="db-icon db-icon-ds-exclamation-bg"></i>
                            <div class="warn-message"
                                 [innerHTML]="'text_rechargePaymentFailedUnavailableGeneral' | dbText">
                            </div>
                        </div>
                        <a class="ds-btn {{isMobile ? 'ds-btn-max' : 'ds-btn-s'}} ds-btn-white-gray-border"
                           (click)="onRetryUserSubscription.emit(userSubscription)"><span>Retry Payment</span></a>
                    } @else if (!paymentMethods?.length) {
                        <span class="warn-message">
          <b>Additional fees can’t be charged via PayPal. </b>
          <a class="text-underline" (click)="onAddPaymentMethod.emit(true)"> Add an alternative payment method</a>
          for additional payments such as extra visits, SSD storage and more.
      </span>
                    }
                </div>
            </div>
            <div class="db-recharge-content">
                <div class="expiration-date-title">Free trial <span class="db-label-red">Ended</span></div>
                <div class="expiration-notif-retry">
                    Your payment of ${{
                        (userSubscription.plan.priceDiscounted / (userSubscription.plan.periodNumber === 1
                        && userSubscription.plan.periodTypeText !== 'Monthly' ? 12 : 1))| number: '1.0-0'
                    }} will be charged
                    on {{ userSubscription.nextBillingDate| date: 'MMM d, yyyy' }}.
                </div>
            </div>
        </div>
    } @else {
        <div class="expiration-date-container api-reseller-trial">
            <div class="expiration-date-title"><span class="api-reseller-trial" [innerHTML]="(daysUntilNext > 1 ? 'text_daysForFree_plural' : 'text_daysForFree_singular') | dbText: {days: daysUntilNext}"></span>
            </div>
            <db-progress-bar
                    [state]="'black'"
                    [progressPercent]="percentageLeft">
            </db-progress-bar>
            <div class="expiration-notif" [innerHTML]="(userSubscription?.plan?.trialPeriodDays > 1 ? 'text_noChargeAfterDayUnlessYouChooseToUpgrade_plural' : 'text_noChargeAfterDayUnlessYouChooseToUpgrade_singular') | dbText: {day: userSubscription?.plan?.trialPeriodDays}">
            </div>
        </div>
    }

    <div class="sub-status-container" [class.trial]="userSubscription?.trialClient && userSubscription?.wvcUsage">
        @if (userSubscription?.trialClient && userSubscription?.wvcUsage) {
            <db-trial-plan-details [usedAiCredits]="vibeLimitationData"
                                   [userSubscription]="userSubscription"
                                   [companyName]="companyName"
                                   [percentageLeft]="percentageLeft"></db-trial-plan-details>
        }
        <div class="sub-status-actions" *ngIf="!userSubscription?.apiResellerFree">
            <div class="section-actions" [class.disabled]="(userSubscription.isExpired ||
             userSubscription.status === userSubscriptionStatus.canceled || userSubscription?.recharge) && !userSubscription?.isApiResellerPlan">
                <div class="ds-btn-purple-blue"
                     [style.width]="'99px'" [style.height]="'36px'"
                     (click)="onUpgradeClick()"><span>{{ 'text_upgrade' | dbText}}</span></div>
            </div>
        </div>
    </div>
</section>
